var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status",class:{'is-valid':_vm.valid,'border':_vm.border,'padding':_vm.padding}},[_c('TextSimple',{attrs:{"color":"black","size":_vm.size}},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }